var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "guild_main"
    },
    [
      _c("div", { staticClass: "guild_color" }, [
        _c("div", { staticClass: "guild_title fc-flex-vcenter fc-wrap" }, [
          _c("div", { staticClass: "guild_font fc-mar-r-sm" }, [
            _vm._v("\n        " + _vm._s(_vm.model.guildName) + "\n      ")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fc-flex fc-flex-vcenter" },
            [
              _c("span", { staticClass: "fc-mar-r-min guild_font" }, [
                _vm._v(
                  _vm._s(_vm.$t("m.agency_ID", { msg_ss: +_vm.model.guildId }))
                )
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.copyTxt(_vm.model.guildId),
                      expression: "copyTxt(model.guildId)",
                      arg: "copy"
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: _vm.onCopy,
                      expression: "onCopy",
                      arg: "success"
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:error",
                      value: _vm.onError,
                      expression: "onError",
                      arg: "error"
                    }
                  ],
                  staticStyle: { padding: "0 10px", height: "24px" },
                  attrs: { type: "primary", size: "mini", round: "" }
                },
                [_vm._v(_vm._s(_vm.$t("m.copy")))]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "fc-flex fc-flex-vcenter" },
          [
            _c("div", [_vm._v(_vm._s(_vm.$t("m.invite_live_join")) + ": ")]),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-right": "5px" } }, [
              _vm._v(_vm._s(_vm.model.shortUrl))
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.copyTxt(_vm.model.shortUrl),
                    expression: "copyTxt(model.shortUrl)",
                    arg: "copy"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:success",
                    value: _vm.onCopy,
                    expression: "onCopy",
                    arg: "success"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:error",
                    value: _vm.onError,
                    expression: "onError",
                    arg: "error"
                  }
                ],
                staticStyle: { padding: "0 10px", height: "24px" },
                attrs: { type: "primary", size: "small", round: "" }
              },
              [_vm._v(_vm._s(_vm.$t("m.copy")))]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "fc-flex fc-flex-vcenter",
            staticStyle: { "margin-top": "10px" }
          },
          [
            _c("div", { staticStyle: { "margin-right": "5px" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("m.invite_guild_url", { msg_ss: _vm.inviteUrl })
                ) + " "
              )
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.copyTxt(_vm.inviteUrl),
                    expression: "copyTxt(inviteUrl)",
                    arg: "copy"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:success",
                    value: _vm.onCopy,
                    expression: "onCopy",
                    arg: "success"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:error",
                    value: _vm.onError,
                    expression: "onError",
                    arg: "error"
                  }
                ],
                staticStyle: { padding: "0 10px", height: "24px" },
                attrs: { type: "primary", size: "small", round: "" }
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("m.copy")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:copy",
                    value: _vm.copyTxt(
                      _vm.$t("m.invite_guild_code", {
                        msg_ss: _vm.model.inviteCode
                      })
                    ),
                    expression:
                      "copyTxt($t('m.invite_guild_code', { 'msg_ss': model.inviteCode}))",
                    arg: "copy"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:success",
                    value: _vm.onCopy,
                    expression: "onCopy",
                    arg: "success"
                  },
                  {
                    name: "clipboard",
                    rawName: "v-clipboard:error",
                    value: _vm.onError,
                    expression: "onError",
                    arg: "error"
                  }
                ],
                staticStyle: { padding: "0 10px", height: "24px" },
                attrs: { type: "primary", size: "small", round: "" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("m.invite_guild_code", {
                        msg_ss: _vm.model.inviteCode
                      })
                    ) +
                    "\n      "
                )
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "guild_color guild_margin guildForm" },
        [
          _c(
            "el-row",
            { staticClass: "guild_title", attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                [
                  _c("span", { staticClass: "decorate_line" }),
                  _vm._v("  \n        "),
                  _c(
                    "span",
                    {
                      staticStyle: { "font-size": "16px", "font-weight": "500" }
                    },
                    [_vm._v(_vm._s(_vm.$t("m.base_info")))]
                  ),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "font-size": "12px" } }, [
                    _vm._v(_vm._s(_vm.$t("m.note")))
                  ]),
                  _vm._v(" "),
                  _vm.setState
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.editDetailDebounce }
                        },
                        [_vm._v(_vm._s(_vm.$t("m.save")))]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.doEdit }
                        },
                        [_vm._v(_vm._s(_vm.$t("m.compile")))]
                      ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    { attrs: { type: "text" }, on: { click: _vm.getEditLog } },
                    [_vm._v(_vm._s(_vm.$t("m.edit_log")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.editLoading,
                  expression: "editLoading"
                }
              ],
              ref: "createForm",
              attrs: {
                size: "mini",
                model: _vm.model,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "guild_col",
                          staticStyle: { display: "flex", "flex-wrap": "wrap" }
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("m.agency_logo")) + ": ")
                          ]),
                          _vm._v(" "),
                          _vm.model.guildLogo
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "img-thumb",
                                  attrs: { src: _vm.model.guildLogo },
                                  on: {
                                    click: function($event) {
                                      return _vm.showPicPreviewDialog(
                                        _vm.model.guildLogo
                                      )
                                    }
                                  }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.setState
                            ? _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  class: {
                                    hideUploadBtn: _vm.guildLogoArr.length > 0
                                  },
                                  attrs: {
                                    action: _vm.uploadAction,
                                    "list-type": "picture",
                                    multiple: false,
                                    "on-remove": _vm.removeLogoUpload,
                                    "on-success": _vm.onUploadLogo,
                                    "on-error": _vm.onUploadError,
                                    "file-list": _vm.guildLogoArr,
                                    "before-upload": _vm.beforeLogoUpload,
                                    accept: ".jpg,.png,.jpeg",
                                    "show-file-list": false
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        color: "#008AFF",
                                        "text-decoration": "underline",
                                        "margin-left": "10px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("m.edit")))]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.setState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("m.agency_contact_name") + ":",
                                prop: "guildContacts"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: {
                                  maxlength: "20",
                                  placeholder: _vm.$t("m.user_contact_name")
                                },
                                model: {
                                  value: _vm.model.guildContacts,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "guildContacts",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.guildContacts"
                                }
                              })
                            ],
                            1
                          )
                        : _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("m.agency_contact_name")) +
                                ": " +
                                _vm._s(_vm.model.guildContacts)
                            )
                          ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.setState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("m.agency_contact_phone") + ":",
                                prop: "guildContactsPhone"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "fc-flex fc-flex-vcenter" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "seledArea",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.showCountryFun.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "flag_icon",
                                        attrs: { src: _vm.selCountry.logo }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "countrynum",
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "45px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "+" +
                                              _vm._s(_vm.selCountry.countryNum)
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        staticClass: "select_icon",
                                        attrs: {
                                          src:
                                            _vm.showCountry &&
                                            _vm.$store.state.isShowSelArea
                                              ? require("../../assets/img/icon_up.png")
                                              : require("../../assets/img/icon_down.png")
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: { width: "150px" },
                                    attrs: {
                                      minlength: "6",
                                      placeholder: _vm.$t(
                                        "m.agency_contact_phone"
                                      )
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.model.guildContactsPhone = _vm.$num(
                                          _vm.model.guildContactsPhone
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.model.guildContactsPhone,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "guildContactsPhone",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "model.guildContactsPhone"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.showCountry &&
                                  _vm.$store.state.isShowSelArea
                                    ? _c(
                                        "div",
                                        { staticClass: "selarea_box" },
                                        [
                                          _c("sel-area", {
                                            on: {
                                              countryOption:
                                                _vm.countryOptionFun
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _c("div", { staticClass: "guild_col" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("m.agency_contact_phone")) +
                                ":\n            "
                            ),
                            _c("span", { staticClass: "direction_ltr" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.model.guildContactsAreaCode
                                    ? "+" + _vm.model.guildContactsAreaCode
                                    : ""
                                ) + _vm._s(_vm.model.guildContactsPhone)
                              )
                            ])
                          ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.setState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("m.agency_whatsapp") + ":",
                                prop: "guildAdminWhatsApp"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  maxlength: "50",
                                  placeholder: _vm.$t(
                                    "m.agency_whatsapp_contact"
                                  )
                                },
                                model: {
                                  value: _vm.model.guildAdminWhatsApp,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "guildAdminWhatsApp",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.guildAdminWhatsApp"
                                }
                              })
                            ],
                            1
                          )
                        : _c("div", { staticClass: "guild_col" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("m.agency_whatsapp")) +
                                ": " +
                                _vm._s(_vm.model.guildAdminWhatsApp) +
                                "\n          "
                            )
                          ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.setState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("m.agency_use_lang") + ":",
                                prop: "guildAdminUserLang"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: _vm.$t("m.select"),
                                    filterable: "",
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.model.guildAdminUserLangToArr,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "guildAdminUserLangToArr",
                                        $$v
                                      )
                                    },
                                    expression: "model.guildAdminUserLangToArr"
                                  }
                                },
                                _vm._l(_vm.guildAdminUserLangArr, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: { label: item.name, value: item.key }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _c("div", { staticClass: "guild_col" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("m.agency_use_lang")) +
                                ": " +
                                _vm._s(
                                  _vm._f("filtersLangArr")(
                                    _vm.model.guildAdminUserLang
                                  )
                                ) +
                                "\n          "
                            )
                          ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c("div", { staticClass: "guild_col" }, [
                        _vm._v(
                          _vm._s(_vm.$t("m.agency_head_ID")) +
                            ": " +
                            _vm._s(_vm.model.guildAdminId) +
                            "\n            "
                        ),
                        _c("i", {
                          staticClass: "el-icon-link",
                          staticStyle: { cursor: "pointer" },
                          on: { click: _vm.changeGuildAdminId }
                        })
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("m.reg_country")) +
                            ": " +
                            _vm._s(_vm.computedCount(_vm.model.phoneCountry))
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "guild_col",
                          staticStyle: { display: "flex", "flex-wrap": "wrap" }
                        },
                        [
                          _c("div", [
                            _vm._v(_vm._s(_vm.$t("m.inhand_ID_photo")) + ": ")
                          ]),
                          _vm._v(" "),
                          _vm.model.guildAdminCardJustPic
                            ? _c("div", [
                                _c("img", {
                                  staticClass: "img-thumb",
                                  attrs: {
                                    src: _vm.model.guildAdminCardJustPic
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showPicPreviewDialog(
                                        _vm.model.guildAdminCardJustPic
                                      )
                                    }
                                  }
                                })
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.setState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("m.mian_form_country") + ":",
                                prop: "anchorCountry"
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    placeholder: _vm.$t("m.select"),
                                    filterable: "",
                                    multiple: ""
                                  },
                                  model: {
                                    value: _vm.model.anchorCountryToArr,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "anchorCountryToArr",
                                        $$v
                                      )
                                    },
                                    expression: "model.anchorCountryToArr"
                                  }
                                },
                                _vm._l(_vm.anchorCountryArr, function(item) {
                                  return _c("el-option", {
                                    key: item.coding + item.id,
                                    attrs: {
                                      label: item.content,
                                      value: item.coding
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _c("div", [
                            _vm._v(
                              _vm._s(_vm.$t("m.mian_form_country")) +
                                ":" +
                                _vm._s(
                                  _vm.computedCount(_vm.model.anchorCountry)
                                )
                            )
                          ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("m.invite_code")) +
                            ": " +
                            _vm._s(_vm.model.superInviteCode)
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("m.apply_time")) +
                            ": " +
                            _vm._s(_vm.model.applyTime)
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("m.join_time")) +
                            ": " +
                            _vm._s(_vm.model.approveTime)
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "guild_title", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.model.cooperationState == 1
                        ? _c("div", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("m.cooper_status")) +
                                ":" +
                                _vm._s(_vm.$t("m.cooper_ing")) +
                                "\n          "
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { xl: 8, lg: 8, md: 12, sm: 12, xs: 24 } },
                    [
                      _vm.setState
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("m.email") + ":",
                                prop: "email"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  maxlength: "50",
                                  placeholder: _vm.$t("m.email")
                                },
                                model: {
                                  value: _vm.model.email,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "email",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "model.email"
                                }
                              })
                            ],
                            1
                          )
                        : _c("div", { staticClass: "guild_col" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("m.email")) +
                                ": " +
                                _vm._s(_vm.model.email) +
                                "\n          "
                            )
                          ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("m.edit_log"),
            visible: _vm.dialogTableVisible,
            close: _vm.closeLogDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading"
                }
              ],
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  property: "createTime",
                  label: _vm.$t("m.edit_time"),
                  fixed: _vm.$store.state.localeLang == "ar" ? false : true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "guildName",
                  label: _vm.$t("m.agency_name"),
                  fixed: _vm.$store.state.localeLang == "ar" ? false : true
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "guildLogo", label: _vm.$t("m.agency_logo") }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "guildContacts",
                  label: _vm.$t("m.agency_contact_name")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "guildContactsPhone",
                  label: _vm.$t("m.agency_contact_phone")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "guildAdminWhatsApp",
                  label: _vm.$t("m.agency_whatsapp")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "guildAdminUserLang",
                  label: _vm.$t("m.agency_use_lang")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("filtersLangArr")(
                                scope.row.guildAdminUserLang
                              )
                            ) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "guildAdminId",
                  label: _vm.$t("m.agency_head_ID")
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "anchorCountry",
                  label: _vm.$t("m.mian_form_country")
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.computedCount(scope.row.anchorCountry)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "email", label: _vm.$t("m.email") }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.show,
            title: _vm.$t("m.preview"),
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog, "show", $event)
            }
          }
        },
        [
          _c("img", {
            staticClass: "img-preview",
            attrs: { src: _vm.dialog.picSrc }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialog.picture.show,
            title: _vm.$t("m.preview") + ":",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog.picture, "show", $event)
            },
            close: _vm.resetInfoForm
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialog.picture.loading,
                  expression: "dialog.picture.loading"
                }
              ]
            },
            [
              _c(
                "el-carousel",
                {
                  attrs: {
                    autoplay: false,
                    "indicator-position": "none",
                    arrow: "always"
                  }
                },
                _vm._l(_vm.dialog.picture.fileList, function(item, index) {
                  return _c("el-carousel-item", { key: index }, [
                    _c("img", {
                      staticClass: "img-preview",
                      attrs: { src: item }
                    })
                  ])
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("ChangeGuildAdminDialog", {
        ref: "refChangeGuildAdminDialog",
        on: { success: _vm.changeSuccess }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23feb3d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23feb3d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guild/myGuildDetailPage.vue
// module id = null
// module chunks = 